export const ROUTES = {
    OVERVIEW: "overview",
    TABLE: "table",
    ANALYTICS: "analytics",
    LOGIN: "login",
    SIGNUP: "signup",
    HOME: "home",
    AGENTS: "agents",
    ASSISTANTS: "assistants",
    AI_STUDIO: "ai-studio",
    LIBRARY: "library",
    ORGANISATION: "organisation",
    STUDIO: "studio",
    USER: "user",
} as const;

export const PATHS = {
    HOME: "/",
    OVERVIEW: `/${ROUTES.OVERVIEW}`,
    TABLE: `/${ROUTES.OVERVIEW}/${ROUTES.TABLE}`,
    ANALYTICS: `/${ROUTES.OVERVIEW}/${ROUTES.ANALYTICS}`,
    LOGIN: `/${ROUTES.LOGIN}`,
    SIGNUP: `/${ROUTES.SIGNUP}`,
    AGENTS: `/${ROUTES.AGENTS}`,
    ASSISTANTS: `/${ROUTES.ASSISTANTS}`,
    AI_STUDIO: `/${ROUTES.AI_STUDIO}`,
    AI_STUDIO_AGENTS: `/${ROUTES.AI_STUDIO}?type=${ROUTES.AGENTS}`,
    AI_STUDIO_ASSISTANTS: `/${ROUTES.AI_STUDIO}?type=${ROUTES.ASSISTANTS}`,
    LIBRARY: `/${ROUTES.LIBRARY}`,
    ORGANISATION: `/${ROUTES.ORGANISATION}`,
    STUDIO: `/${ROUTES.STUDIO}`,
    USER: `/${ROUTES.USER}`,
} as const;

export const nonProtectedPaths = [
    PATHS.LOGIN,
    PATHS.SIGNUP,
];

export const menuDisplayedOnPages = [
    PATHS.HOME,
    PATHS.AGENTS,
    PATHS.ASSISTANTS,
    PATHS.AI_STUDIO,
    PATHS.LIBRARY,
    PATHS.ORGANISATION,
    PATHS.STUDIO,
    PATHS.USER,
    PATHS.OVERVIEW,
];